import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import StickyNote2 from "@mui/icons-material/StickyNote2";
import Add from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import SwapVertIcon from "@mui/icons-material/SwapVert";

const OptionsMenu = ({
    data,
    ord,
    nodeType,
    father,
    log,
    fatherIconState = {}, // Valor por defecto para evitar errores
    dataLog,
    setDataDetails,
    setOpenModalLog,
    setDetailLog,
    handleCreate,
    handleEditBodyComponent,
    handleDeleteSubComponet,
    handleEditComponet,
    HideNodes,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const iconState = fatherIconState?.[ord];

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const executeAction = (action, ...args) => {
        action(...args);
        handleClose();
    };

    if (log) {
        return (
            <IconButton
                onClick={() => {
                    if (nodeType !== "ROOT") {
                        setDataDetails(data);
                    } else {
                        setOpenModalLog(true);
                        setDetailLog(dataLog);
                    }
                }}
            >
                <StickyNote2 />
            </IconButton>
        );
    }

    return (
        <Box>
            <IconButton
                aria-label="more"
                aria-controls={open ? "options-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>

            <Menu
                id="options-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{ style: { width: "220px" } }}
            >
                {father && (
                    <MenuItem onClick={() => executeAction(HideNodes, data.order)}>
                        <ListItemIcon>
                            {iconState ? <VisibilityOff fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                        </ListItemIcon>
                        <ListItemText primary={iconState ? "Mostrar" : "Ocultar"} />
                    </MenuItem>
                )}

                {nodeType === "DEC" ? (
                    [
                        <MenuItem key="add-f" onClick={() => executeAction(handleCreate, `${ord}.0`)}>
                            <ListItemIcon><Add fontSize="small" sx={{ color: "red" }} /></ListItemIcon>
                            <ListItemText primary="Agregar - false" />
                        </MenuItem>,
                        <MenuItem key="add-t" onClick={() => executeAction(handleCreate, `${ord}.1`)}>
                            <ListItemIcon><Add fontSize="small" sx={{ color: "green" }} /></ListItemIcon>
                            <ListItemText primary="Agregar - true" />
                        </MenuItem>
                    ]
                ) : (
                    <MenuItem onClick={() => executeAction(handleCreate, nodeType === "ROOT" ? "" : ord)}>
                        <ListItemIcon><Add fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Agregar" />
                    </MenuItem>
                )}

                {nodeType !== "ROOT" && [
                    <MenuItem key="edit" onClick={() => executeAction(handleEditBodyComponent, data)}>
                        <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Editar" />
                    </MenuItem>,
                    <MenuItem key="delete" onClick={() => executeAction(handleDeleteSubComponet, ord)}>
                        <ListItemIcon><Delete fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Eliminar" />
                    </MenuItem>,
                    <MenuItem key="reorder" onClick={() => executeAction(handleEditComponet, data)}>
                        <ListItemIcon><SwapVertIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Editar input o posición" />
                    </MenuItem>
                ]}
            </Menu>
        </Box>
    );
};

export default OptionsMenu;